'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './contact-show.routes';

export class ContactShowComponent {
  constructor($stateParams, ContactService, $uibModal, $window, PropertyService, WebAccessService, SettingsService) {
    'ngInject';

    this.back = _ => $window.history.back();

    this.contactId = $stateParams.id;
    this.$uibModal = $uibModal;

    this.ContactService = ContactService;
    this.PropertyService = PropertyService;

    WebAccessService.getByContact({contactId: this.contactId}, data => {
      this.webaccess = data;
    });

    this.refreshData();
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {

      composedName = contact.firstName;


      if (contact.middleName)
        composedName += " " + contact.middleName;

      composedName += " " + contact.lastName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += ", " + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  getAddress(address) {
    try {
      let _address = angular.copy(address);

      if (!_address.street) _address.street = "-";
      if (!_address.city) _address.city = "-";
      if (!_address.state) _address.state = "-";
      if (!_address.zip) _address.zip = "-";

      return `${_address.street}, ${_address.city} ${_address.state}, ${_address.zip}`;
    } catch (e){
      return "-";
    }
  }

  refreshData() {
    if (this.contactId) {
      this.ContactService.get({id: this.contactId}, data => {
        this.contact = data;

        this.PropertyService.getPropertiesByVoter({contactId: this.contactId}, data => {
          this.voterRelations = data.map(property => {
              return {
                type: "Property",
                propertyId: property._id,
                property: this.getAddress(property.address) + ` / ${property.lotNo}`,
                lotNo: property.lotNo
              }
          });
        });

        this.PropertyService.getByContact({contactId: this.contactId}, data => {
          this.propertyRelations = data.map(property => {
            let idx = property.contacts.findIndex(contact => { return contact.contact == this.contactId; });

            if (idx != -1) {
              return {
                type: property.contacts[idx].type.split('-').join(' '),
                propertyId: property._id,
                property: this.getAddress(property.address) + ` / ${property.lotNo}`,
                lotNo: property.lotNo
              }
            }
          });

        });

      }, err => {
        console.log('Could not load contact from server');
      });
    }
  }
}

export default angular.module('conduu.contactShow', [uiRouter])
  .config(routes)
  .component('contactShow', {
    template: require('./contact-show.html'),
    controller: ContactShowComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-show/contact-show.component.js